import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

export const getModels = createAsyncThunk('get/models', async () => {
  const response = await axios.get('/model/');
  return response.data;
});

export const getModelById = createAsyncThunk('getModelById/models', async ({ modelID }) => {
  const response = await axios.get(`/model/${modelID}`);
  return response.data;
});

export const getModelsByBrand = createAsyncThunk('getModelsByBrand/model', async ({ brandID }) => {
  const response = await axios.get(`/model/${brandID}/retrieve_by_brand`);
  return response.data;
});

export const addModel = createAsyncThunk('add/model', async (model, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post('/model/', model);
    dispatch(getModels());
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateModel = createAsyncThunk(
  'update/model',
  async ({ model, modelData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(`/model/${model}/`, modelData);
      dispatch(getModels());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteModel = createAsyncThunk('delete/model', async (modelId, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.delete(`/model/${modelId}/`);
    dispatch(getModels());
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteManyModels = createAsyncThunk(
  'deleteMany/model',
  async (modelIDs, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete('/model/delete_many/', { data: { arrId: modelIDs } });
      dispatch(getModels());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const modelAdapter = createEntityAdapter({});

const modelSlice = createSlice({
  name: 'model',
  initialState: modelAdapter.getInitialState({
    models: [],
    currentModel: '',
    modelsByBrand: [],
    modelById: '',
    searchText: '',
    routeParams: {},
    loading: false,
    isSubmitting: false,
  }),
  reducers: {
    setSearchText: (state, action) => {
      state.searchText = action.payload;
    },
  },
  extraReducers: {
    [addModel.pending]: (state) => {
      state.isSubmitting = true;
    },

    [addModel.fulfilled]: (state) => {
      state.isSubmitting = false;
    },

    [addModel.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ---------------------------------------------
    [getModels.pending]: (state) => {
      state.loading = true;
    },
    [getModels.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.models = data;
      state.loading = false;
    },
    [getModels.rejected]: (state) => {
      state.loading = false;
    },
    // ---------------------------------------------
    [getModelsByBrand.fulfilled]: (state, action) => {
      state.modelsByBrand = action.payload.data;
    },
    // ---------------------------------------------
    [getModelById.fulfilled]: (state, action) => {
      state.modelById = action.payload.data;
    },
    // ---------------------------------------------
    [updateModel.pending]: (state) => {
      state.isSubmitting = true;
    },
    [updateModel.fulfilled]: (state) => {
      modelAdapter.upsertOne, (state.isSubmitting = false);
    },
    [updateModel.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ---------------------------------------------
    [deleteModel.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteModel.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteModel.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ---------------------------------------------
    [deleteManyModels.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteManyModels.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteManyModels.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ---------------------------------------------
  },
});

export const { openNewModelDialog, closeNewModelDialog, openEditModelDialog, closeEditModelDialog, setSearchText } =
  modelSlice.actions;

export default modelSlice.reducer;
